export class CompanyRemainingLimit {
  private fiscalNumber: string;
  private remainingLimitValue: number;

  public getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  public setFiscalNumber(fiscalNumber: string) {
    this.fiscalNumber = fiscalNumber;
  }

  public getRemainingLimitValue(): number {
    return this.remainingLimitValue;
  }

  public setRemainingLimitValue(remainingLimitValue: number) {
    this.remainingLimitValue = remainingLimitValue;
  }
}
